import { Component, Prop, h, Event, EventEmitter } from '@stencil/core';
import { InputFomat } from '../model/input.model';

@Component({
  tag: 'form-checkbox',
  styleUrl: 'form-checkbox.css',
  shadow: false,
})
export class FormCheckbox {
  @Prop() inputValue: InputFomat;
  @Event() valueChanged: EventEmitter<{ id: string; value: any }>;


  private handleInput = (event: Event) => {
    const target = event.target as HTMLInputElement;
    const value = this.inputValue.type === 'checkbox' ? target.checked : target.value;
    this.valueChanged.emit({ id: this.inputValue.id, value });
  };


  render() {
    return (

        <div class="form-box">
          <ix-checkbox
            label={this.inputValue.label || this.inputValue.id}
            type="checkbox"
            id={this.inputValue.id}
            checked={!!this.inputValue[this.inputValue.id]}
            onClick={(event) => this.handleInput(event)}
          />
          <br />
        </div>
    );
  }
}
